import {createReducer, on} from '@ngrx/store';
import {
  ClearState,
  FetchDashboardFilterFailure,
  FetchDashboardFilterRequest,
  FetchDashboardFilterSuccess,
  FetchGroupDashboardParticipantBehaviorPhysicalActivityDataFailure,
  FetchGroupDashboardParticipantBehaviorPhysicalActivityDataRequest,
  FetchGroupDashboardParticipantBehaviorPhysicalActivityDataSuccess,
  FetchGroupDashboardParticipantBehaviorRedLightsDataFailure,
  FetchGroupDashboardParticipantBehaviorRedLightsDataRequest,
  FetchGroupDashboardParticipantBehaviorRedLightsDataSuccess,
  FetchGroupDashboardParticipantBehaviorScreenTimeDataFailure,
  FetchGroupDashboardParticipantBehaviorScreenTimeDataRequest,
  FetchGroupDashboardParticipantBehaviorScreenTimeDataSuccess,
  FetchGroupDashboardParticipantInformationDataFailure,
  FetchGroupDashboardParticipantInformationDataRequest,
  FetchGroupDashboardParticipantInformationDataSuccess,
  FetchGroupDashboardParticipantWeightDataFailure,
  FetchGroupDashboardParticipantWeightDataRequest,
  FetchGroupDashboardParticipantWeightDataSuccess,
  FetchGroupsTypeFilterFailure,
  FetchGroupsTypeFilterRequest,
  FetchGroupsTypeFilterSuccess,
  FetchParticipantsAndCaregiversListFailure,
  FetchParticipantsAndCaregiversListRequest,
  FetchParticipantsAndCaregiversListSuccess,
  FetchParticipantsBehaviourListFailure,
  FetchParticipantsBehaviourListRequest,
  FetchParticipantsBehaviourListSuccess,
  FetchParticipantsWeightListFailure,
  FetchParticipantsWeightListRequest,
  FetchParticipantsWeightListSuccess,
  FetchUserStatusListFilterFailure,
  FetchUserStatusListFilterRequest,
  FetchUserStatusListFilterSuccess,
  SaveConfigId
} from './group-dashboard.actions';
import {
  GroupDashboardParticipantInformationModel
} from 'src/app/models/group-dashboard-participant-information.model';
import {
  GroupDashboardParticipantWeightModel
} from 'src/app/models/group-dashboard-participant-weight.model';
import {
  GroupDashboardParticipantBehaviorRedLightsModel
} from 'src/app/models/group-dashboard-participant-behavior-red-lights.model';
import {
  GroupDashboardParticipantBehaviorPhysicalActivityModel
} from 'src/app/models/group-dashboard-participant-behavior-physical-activity-model';
import {
  GroupDashboardParticipantBehaviorScreenTimeModel
} from 'src/app/models/group-dashboard-participant-behavior-screen-time-model';
import {
  ParticipantsAndCaregiversList
} from '../../../../models/participants-and-caregivers-list';
import {Filter} from '../../../../models/filter';
import {
  ParticipantsWeightList
} from '../../../../models/participants-weight-list';
import {
  ParticipantsBehaviourList
} from "../../../../models/participants-behaviour-list";

export interface GroupDashboardState {
  groupDashboardParticipantInformation: GroupDashboardParticipantInformationModel;
  groupDashboardParticipantWeight: GroupDashboardParticipantWeightModel;
  groupDashboardParticipantBehaviorRedLights: GroupDashboardParticipantBehaviorRedLightsModel;
  groupDashboardParticipantBehaviorPhysicalActivity: GroupDashboardParticipantBehaviorPhysicalActivityModel;
  groupDashboardParticipantBehaviorScreenTime: GroupDashboardParticipantBehaviorScreenTimeModel;
  loading: boolean,
  dashboardFilter: Filter;
  participantsAndCaregiversList: ParticipantsAndCaregiversList;
  groupsTypeFilter: Filter;
  userStatusListFilter: Filter,
  participantsWeightList: ParticipantsWeightList,
  participantsBehaviourList: ParticipantsBehaviourList;
  configId: number,
}

const initialState: GroupDashboardState = {
  groupDashboardParticipantInformation: {
    participantInformation: [],
    average: {
      averageAge: null,
      averageAttendance: null,
      lastSession: null,
      maleToFemaleRatio: null
    }

  },
  groupDashboardParticipantWeight: {
    participantWeight: [],
    average: {
      currentWeight: null,
      weightChangeSinceBaseLine: null,
      weightLossAlert: null,
      currentBMI: null,
      changeBMI: null,
      medianBMI: null,
      overallBMIChange: null,
      overIle: null,
      changeOverIle: null,
    }
  },
  groupDashboardParticipantBehaviorRedLights: {
    average: {
      numberOfDaysJournaledLastWeek: null,
      readLightsGoalForLastWeek: null,
      redLightsLastWeek: null,
      overallDaysJournaled: null,
      numberOfDaysRedLightsGoalsSet: null,
      numberOfRedLightsGoalsMet: null,
    }, participantBehaviorRedLights: []
  },
  groupDashboardParticipantBehaviorPhysicalActivity: {
    participantBehaviorPhysicalActivity: [],
    average: {
      numberOfDaysJournaledLastWeek: null,
      physicalActivityGoalForLastWeek: null,
      physicalActivityGoalAchievedForLastWeek: null,
      overallDaysJournaled: null,
      numberOfDaysPhysicalActivityGoalsSet: null,
      numberOfPhysicalActivityGoalsMet: null,
    }
  },
  groupDashboardParticipantBehaviorScreenTime: {
    participantBehaviorScreenTime: [],
    average: {
      numberOfDaysJournaledLastWeek: null,
      screenTimeGoalForLastWeek: null,
      screenTimeGoalAchievedForLastWeek: null,
      overallDaysJournaled: null,
      numberOfScreenTimeGoalsSet: null,
      numberOfScreenTimeGoalsMet: null,
    }
  },
  loading: false,
  dashboardFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  participantsAndCaregiversList: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  groupsTypeFilter: {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  userStatusListFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  participantsWeightList: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  configId: 1,
  participantsBehaviourList: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
};

export const reducer = createReducer(
  initialState,

  //clear state
  on(ClearState, (state) => initialState),

  /* FetchGroupDashboardParticipantInformationData */
  on(FetchGroupDashboardParticipantInformationDataRequest, (state) => ({...state, loading: true})),
  on(FetchGroupDashboardParticipantInformationDataSuccess, (state, props) => ({
    ...state,
    groupDashboardParticipantInformation:
    props.groupDashboardParticipantInformation,
    groupDashboardParticipantWeight: {
      participantWeight: [],
      average: null
    },
    groupDashboardParticipantBehaviorRedLights: {
      average: null, participantBehaviorRedLights: []
    },
    groupDashboardParticipantBehaviorPhysicalActivity: {
      participantBehaviorPhysicalActivity: [], average: null
    },
    groupDashboardParticipantBehaviorScreenTime: {
      average: null, participantBehaviorScreenTime: []
    },
    loading: false
  })),
  on(FetchGroupDashboardParticipantInformationDataFailure, (state) => ({...state, loading: false})),

  /* fetchGroupDashboardParticipantWeight */
  on(FetchGroupDashboardParticipantWeightDataRequest, (state) => ({...state, loading: true})),
  on(FetchGroupDashboardParticipantWeightDataSuccess, (state, props) => ({
    ...state,
    groupDashboardParticipantWeight: {
      average: {...props.groupDashboardParticipantWeight.average},
      participantWeight: props.groupDashboardParticipantWeight.participantWeight
    },
    groupDashboardParticipantInformation: {
      participantInformation: [],
      average: null
    },
    groupDashboardParticipantBehaviorRedLights: {
      average: null, participantBehaviorRedLights: []
    },
    groupDashboardParticipantBehaviorPhysicalActivity: {
      participantBehaviorPhysicalActivity: [], average: null
    },
    groupDashboardParticipantBehaviorScreenTime: {
      average: null, participantBehaviorScreenTime: []
    },
    loading: false
  })),
  on(FetchGroupDashboardParticipantWeightDataFailure, (state) => ({...state, loading: false})),

  /* FetchGroupDashboardParticipantBehaviorRedLights */
  on(FetchGroupDashboardParticipantBehaviorRedLightsDataRequest, (state) => ({...state, loading: true})),
  on(FetchGroupDashboardParticipantBehaviorRedLightsDataSuccess, (state, props) => ({
    ...state,
    groupDashboardParticipantBehaviorRedLights:
      {
        average: {...props.groupDashboardParticipantBehaviorRedLights.average},
        participantBehaviorRedLights: [...props.groupDashboardParticipantBehaviorRedLights.participantBehaviorRedLights]
      },
    groupDashboardParticipantInformation: {
      participantInformation: [],
      average: null
    },
    groupDashboardParticipantWeight: {
      participantWeight: [],
      average: null
    },
    groupDashboardParticipantBehaviorPhysicalActivity: {
      participantBehaviorPhysicalActivity: [],
      average: null
    },
    groupDashboardParticipantBehaviorScreenTime: {
      average: null,
      participantBehaviorScreenTime: []
    },
    loading: false
  })),
  on(FetchGroupDashboardParticipantBehaviorRedLightsDataFailure, (state) => ({...state, loading: false})),

  /* DashboardGroupsParticipantPhysicalActivity  */
  on(FetchGroupDashboardParticipantBehaviorPhysicalActivityDataRequest, (state) => ({...state, loading: true})),
  on(FetchGroupDashboardParticipantBehaviorPhysicalActivityDataSuccess, (state, props) => ({
    ...state,
    groupDashboardParticipantBehaviorPhysicalActivity:
      {
        average: {...props.groupDashboardParticipantBehaviorPhysicalActivity.average},
        participantBehaviorPhysicalActivity: [...props.groupDashboardParticipantBehaviorPhysicalActivity.participantBehaviorPhysicalActivity]
      },
    groupDashboardParticipantInformation: {
      participantInformation: [],
      average: null
    },
    groupDashboardParticipantBehaviorScreenTime: {
      average: null,
      participantBehaviorScreenTime: []
    },
    groupDashboardParticipantBehaviorRedLights: {
      average: null,
      participantBehaviorRedLights: []
    },
    groupDashboardParticipantWeight: {
      participantWeight: [],
      average: null
    }, loading: false
  })),
  on(FetchGroupDashboardParticipantBehaviorPhysicalActivityDataFailure, (state) => ({...state, loading: false})),

  /* DashboardGroupsParticipantPhysicalActivity  */
  on(FetchGroupDashboardParticipantBehaviorScreenTimeDataRequest, (state) => ({...state, loading: true})),
  on(FetchGroupDashboardParticipantBehaviorScreenTimeDataSuccess,
    (state, props) => ({
      ...state,
      groupDashboardParticipantBehaviorScreenTime:
        {
          average: {...props.groupDashboardParticipantBehaviorScreenTime.average},
          participantBehaviorScreenTime: [...props.groupDashboardParticipantBehaviorScreenTime.participantBehaviorScreenTime]
        },
      groupDashboardParticipantBehaviorPhysicalActivity: {
        participantBehaviorPhysicalActivity: [],
        average: null
      },
      groupDashboardParticipantInformation: {
        participantInformation: [],
        average: null
      },
      groupDashboardParticipantBehaviorRedLights: {
        average: null,
        participantBehaviorRedLights: []
      },
      groupDashboardParticipantWeight: {
        participantWeight: [],
        average: null,
      }, loading: false
    })),
  on(FetchGroupDashboardParticipantBehaviorScreenTimeDataFailure, (state) => ({...state, loading: false})),

  // FETCH DASH BOARD FILTER
  on(FetchDashboardFilterRequest, (state) => ({
    ...state,
    dashboardFilter: {
      ...initialState.dashboardFilter,
      loading: true
    }
  })),
  on(FetchDashboardFilterSuccess, (state, props) => ({
    ...state,
    dashboardFilter: {
      ...props.dashboardFilter,
      loading: false
    }
  })),
  on(FetchDashboardFilterFailure, (state) => ({
    ...state,
    dashboardFilter: {
      ...initialState.dashboardFilter,
      loading: false
    }
  })),

  // FETCH PARTICIPANT AND CAREGIVERS LIST
  on(FetchParticipantsAndCaregiversListRequest, (state, props) => ({
    ...state,
    participantsAndCaregiversList: {
      ...state.participantsAndCaregiversList,
      list: [
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.participantsAndCaregiversList.list] :
            []
        )
      ],
      loading: true,
    }
  })),
  on(FetchParticipantsAndCaregiversListSuccess, (state, props) => ({
    ...state,
    participantsAndCaregiversList: {
      ...props.participantsAndCaregiversList,
      loading: false,
      list: [
        ...(props.participantsAndCaregiversList.pageNumber === 1 ? [
          ...props.participantsAndCaregiversList.list
        ] : [
          ...state.participantsAndCaregiversList.list,
          ...props.participantsAndCaregiversList.list
        ])
      ]
    }
  })),
  on(FetchParticipantsAndCaregiversListFailure, (state) => ({
    ...state,
    participantsAndCaregiversList: {
      ...state.participantsAndCaregiversList,
      hasNext: false,
      hasPrev: false,
      loading: false
    }
  })),

  // FETCH GROUPS TYPE FILTER
  on(FetchGroupsTypeFilterRequest, (state) => ({
    ...state,
    groupsTypeFilter: {
      ...initialState.groupsTypeFilter,
      loading: true
    }
  })),
  on(FetchGroupsTypeFilterSuccess, (state, props) => ({
    ...state,
    groupsTypeFilter: {
      ...props.groupsTypeFilter,
      loading: false
    }
  })),
  on(FetchGroupsTypeFilterFailure, (state) => ({
    ...state,
    groupsTypeFilter: {
      ...initialState.groupsTypeFilter,
      loading: false
    }
  })),

  // FETCH USER STATUS LIST FILTER
  on(FetchUserStatusListFilterRequest, (state) => ({
    ...state,
    userStatusListFilter: {
      ...initialState.userStatusListFilter,
      loading: true
    }
  })),
  on(FetchUserStatusListFilterSuccess, (state, props) => ({
    ...state,
    userStatusListFilter: {
      ...props.data,
      loading: false
    }
  })),
  on(FetchUserStatusListFilterFailure, (state) => ({
    ...state,
    userStatusListFilter: {
      ...initialState.userStatusListFilter,
      loading: false
    }
  })),

  // FETCH PARTICIPANT WEIGHT LIST
  on(FetchParticipantsWeightListRequest, (state, props) => ({
    ...state,
    participantsWeightList: {
      ...state.participantsWeightList,
      list: [
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.participantsWeightList.list] :
            []
        )
      ],
      loading: true,
    }
  })),
  on(FetchParticipantsWeightListSuccess, (state, props) => ({
    ...state,
    participantsWeightList: {
      ...props.participantsWeightList,
      loading: false,
      list: [
        ...(props.participantsWeightList.pageNumber === 1 ? [
          ...props.participantsWeightList.list
        ] : [
          ...state.participantsWeightList.list,
          ...props.participantsWeightList.list
        ])
      ]
    }
  })),
  on(FetchParticipantsWeightListFailure, (state) => ({
    ...state,
    participantsWeightList: {
      ...state.participantsWeightList,
      hasNext: false,
      hasPrev: false,
      loading: false
    }
  })),

  // SAVE CONFIG ID
  on(SaveConfigId, (state, props) => ({
    ...state,
    configId: props.configId
  })),


  // FETCH PARTICIPANT BEHAVIOUR LIST
  on(FetchParticipantsBehaviourListRequest, (state, props) => ({
    ...state,
    participantsBehaviourList: {
      ...state.participantsBehaviourList,
      list: [
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.participantsBehaviourList.list] :
            []
        )
      ],
      loading: true
    }
  })),
  on(FetchParticipantsBehaviourListSuccess, (state, props) => ({
    ...state,
    participantsBehaviourList: {
      ...props.participantsBehaviourList,
      loading: false,
      list: [
        ...(props.participantsBehaviourList.pageNumber === 1 ? [
          ...props.participantsBehaviourList.list
        ] : [
          ...state.participantsBehaviourList.list,
          ...props.participantsBehaviourList.list
        ])
      ]
    }
  })),
  on(FetchParticipantsBehaviourListFailure, (state) => ({
    ...state,
    participantsBehaviourList: {
      ...state.participantsBehaviourList,
      loading: false
    }
  })),
);
